import axios, { AxiosRequestConfig } from 'axios';

// Constants
import ENVIRONMENTS from 'constants/enviroments';
import { errorMessagersList } from 'helpers/errorMessagers';
import CONST_AUTH from 'constants/auth';
import PATH from 'constants/basePath';

// Helpers
import { getToken, isAuthenticated, getCompany, setToken } from 'helpers/auth';

// Actions
import { setOpen } from 'store/ducks/snackbars/actions';

// Services
import { auth } from 'services/firebase';
import { onAuthStateChanged, getIdToken } from 'firebase/auth';

// Store
import { history } from 'store';

const apiBase = axios.create({ baseURL: ENVIRONMENTS.ATTENDANCE.BASE_URL_2 });

const callApiBase = (
  call: AxiosRequestConfig & {
    endpoint: string;
    method: AxiosRequestConfig;
    useToken: boolean;
    useApiToken?: boolean;
    data?: any;
    headers?: {};
  },
) => {
  const {
    endpoint,
    method = 'GET',
    useToken = false,
    useApiToken = false,
    params = {},
    data = {},
  } = call;

  // Config Headers
  const defaultHeaders: {
    'Content-Type': string;
    Authorization?: string | null;
    companyid?: string | null;
  } = {
    'Content-Type': 'application/json',
  };

  if (useToken && isAuthenticated()) {
    defaultHeaders.Authorization = getToken();
    defaultHeaders.companyid = getCompany();
  } else if (useApiToken) {
    defaultHeaders.Authorization = `Bearer ${ENVIRONMENTS.ATTENDANCE.REACT_APP_ATTENDANCE_KEY}`;
    defaultHeaders.companyid = getCompany();
  }

  let { headers } = call;
  headers = { ...defaultHeaders, ...headers };
  // End Config Headers

  // Reauth
  onAuthStateChanged(auth, async (user) => {
    if (user) {
      try {
        const idToken = await getIdToken(user);
        setToken(idToken);
      } catch (error) {
        console.error('Error retrieving ID token:', error);
      }
    }
  });

  apiBase.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response.status === 401) {
        localStorage.clear();
        sessionStorage.clear();
        history.replace(PATH.LOGIN);

        setOpen({
          open: true,
          type: 'warning',
          message: errorMessagersList(CONST_AUTH.FIREBASE_FORBIDDEN),
        });
      }

      return Promise.reject(error);
    },
  );

  if (method === 'GET' || method === 'DELETE') {
    return apiBase(endpoint, {
      params: {
        ...params,
      },
      headers,
      method,
    });
  }

  return apiBase(endpoint, {
    headers,
    method,
    params: {},
    data,
  });
};

export default callApiBase;
